/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { StatusWorkflowResponse } from '../../models/status-workflow-response';

export interface StatusWorkflowControllerGetStatusWorkflows$Params {
  type_id?: number;
  name?: string;
  created_on_from?: string;
  created_on_to?: string;
  updated_on_from?: string;
  updated_on_to?: string;
  limit?: number;
  skip?: number;
  query?: string;
}

export function statusWorkflowControllerGetStatusWorkflows(http: HttpClient, rootUrl: string, params?: StatusWorkflowControllerGetStatusWorkflows$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: StatusWorkflowResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, statusWorkflowControllerGetStatusWorkflows.PATH, 'get');
  if (params) {
    rb.query('type_id', params.type_id, {});
    rb.query('name', params.name, {});
    rb.query('created_on_from', params.created_on_from, {});
    rb.query('created_on_to', params.created_on_to, {});
    rb.query('updated_on_from', params.updated_on_from, {});
    rb.query('updated_on_to', params.updated_on_to, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: StatusWorkflowResponse;
      }>;
    })
  );
}

statusWorkflowControllerGetStatusWorkflows.PATH = '/status-workflow';
